import { createRouter, createWebHistory } from "vue-router"
import { pageView } from "@/utils/ga"
import { applyPageStyles, type PageStyleSet } from "@/styles/pageStyles"

declare module "vue-router" {
    interface RouteMeta {
        // GAのpage_viewで送る画面タイトル
        pageTitle: string
        pageStyles: PageStyleSet
    }
}

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "/",
            component: () => import("@/pages/HomePage.vue"),
            meta: { pageTitle: "ホーム", pageStyles: "home" },
        },
        {
            path: "/minicog/start",
            component: () => import("@/pages/MinicogStartPage.vue"),
            meta: { pageTitle: "音声記憶", pageStyles: "measurement" },
        },
        {
            path: "/minicog/remember",
            component: () => import("@/pages/MinicogRememberPage.vue"),
            meta: { pageTitle: "音声記憶", pageStyles: "measurement" },
        },
        {
            path: "/minicog/clock",
            component: () => import("@/pages/MinicogClockPage.vue"),
            meta: { pageTitle: "時計描画", pageStyles: "measurement" },
        },
        {
            path: "/minicog/before_answer",
            component: () => import("@/pages/MinicogBeforeAnswerPage.vue"),
            meta: { pageTitle: "音声回答", pageStyles: "measurement" },
        },
        {
            path: "/minicog/answer",
            component: () => import("@/pages/MinicogAnswerPage.vue"),
            meta: { pageTitle: "音声回答", pageStyles: "measurement" },
        },
        {
            path: "/result",
            component: () => import("@/pages/MeasureResultPage.vue"),
            meta: { pageTitle: "測定結果", pageStyles: "result" },
        },
        // 未定義URLはトップへ戻す
        { path: "/:pathMatch(.*)*", redirect: "/" },
    ],
    // 遷移先は画面上部から表示する
    scrollBehavior: () => ({ top: 0 }),
})

router.beforeResolve((to) => {
    applyPageStyles(to.meta.pageStyles)
})

router.afterEach((to, _from, failure) => {
    if (failure) return
    pageView(to.meta.pageTitle)
})

export default router
